export default {
  respondentList: [],
  errors: {
    getRespondents: ''
  },
  respondentParams: {
    inn: '',
    okpo: ''
  },
  loading: false,
  isShowRefreshBtn: false
}



// WEBPACK FOOTER //
// ./src/store/modules/respondents/state.js